import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useQueryApplicationCount from "../view/useQueryApplicationCount";
import CandidateApprovalStatusEnum from "../../candidates/CandidateApprovalStatusEnum";

export default function ApprovedApplicationByRecruiterCountItem(props) {
  const { recruiterId } = props;
  const { data: count, loading, errors } = useQueryApplicationCount({recruiterId, candidateApprovalStatus: CandidateApprovalStatusEnum.APPROVED});

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <Row>
            <Col>
              <span>{count}</span>
            </Col>
          </Row>
        )}
      />
    </HorizontalLoader>
  );
}
